export default {
  tabMenu: {
    view: 'Layout',
    alarm: 'Alarms',
    loadList: 'Load list',
    movements: 'Movements',
    gantt: 'Gantt chart',
    loadingPlace: 'Loading place',
  },
};
